module.exports = __webpack_public_path__ + "img/02.d7e8bb33.jpg";